import React from 'react';
import { AlertTriangle, XCircle, CheckCircle2, ArrowRight } from 'lucide-react';
import { Card } from '../ui/Card';
export function ProblemSolution() {
  return <>
      {/* PROBLEM SECTION */}
      <section className="py-20 bg-white" data-id="element-210">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-211">
          <div className="text-center mb-12" data-id="element-212">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-213">
              ¿Te sientes frustrada intentando hacer cosmética natural?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-214">
              No eres la única. Muchas mujeres gastan tiempo y dinero en
              ingredientes para terminar con mezclas que no funcionan.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-215">
            <Card className="p-6 border-l-4 border-l-red-400 bg-red-50/30" data-id="element-216">
              <h3 className="flex items-center gap-2 font-bold text-red-800 mb-3" data-id="element-217">
                <XCircle className="w-5 h-5" data-id="element-218" />
                El problema de las "recetas de internet"
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-219">
                <li className="flex gap-2" data-id="element-220">
                  <span className="text-red-400" data-id="element-221">•</span> Las cremas se separan
                  a los dos días.
                </li>
                <li className="flex gap-2" data-id="element-222">
                  <span className="text-red-400" data-id="element-223">•</span> Quedan aguadas o
                  demasiado grasosas.
                </li>
                <li className="flex gap-2" data-id="element-224">
                  <span className="text-red-400" data-id="element-225">•</span> Se llenan de hongos
                  por falta de higiene.
                </li>
                <li className="flex gap-2" data-id="element-226">
                  <span className="text-red-400" data-id="element-227">•</span> Usan medidas inexactas
                  como "tazas" o "cucharas".
                </li>
              </ul>
            </Card>

            <Card className="p-6 border-l-4 border-l-orange-400 bg-orange-50/30" data-id="element-228">
              <h3 className="flex items-center gap-2 font-bold text-orange-800 mb-3" data-id="element-229">
                <AlertTriangle className="w-5 h-5" data-id="element-230" />
                El miedo a dañar tu piel
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-231">
                <li className="flex gap-2" data-id="element-232">
                  <span className="text-orange-400" data-id="element-233">•</span> Irritaciones por pH
                  incorrecto.
                </li>
                <li className="flex gap-2" data-id="element-234">
                  <span className="text-orange-400" data-id="element-235">•</span> Ingredientes
                  fotosensibles mal usados.
                </li>
                <li className="flex gap-2" data-id="element-236">
                  <span className="text-orange-400" data-id="element-237">•</span> Sensación de
                  inseguridad constante.
                </li>
                <li className="flex gap-2" data-id="element-238">
                  <span className="text-orange-400" data-id="element-239">•</span> Desperdicio de
                  dinero en insumos caros.
                </li>
              </ul>
            </Card>
          </div>

          {/* AGITATION */}
          <div className="bg-gray-50 p-8 rounded-2xl text-center mb-20" data-id="element-240">
            <p className="text-xl font-medium text-gray-800 italic" data-id="element-241">
              "Solo quieres cuidar tu piel y la de tu familia con productos
              naturales, pero la falta de un método claro te detiene."
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION / BIG IDEA */}
      <section className="py-20 bg-[#4A6741] text-white relative overflow-hidden" data-id="element-242">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-243"></div>

        <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-244">
          <div className="text-center mb-16" data-id="element-245">
            <span className="inline-block py-1 px-3 rounded-full bg-white/20 text-white text-sm font-bold tracking-wider mb-4" data-id="element-246">
              LA SOLUCIÓN DEFINITIVA
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-247">
              Descubre el{' '}
              <span className="text-[#F5F2EA] underline decoration-4 decoration-[#C06C54]" data-id="element-248">
                Método Natural Care
              </span>
            </h2>
            <p className="text-xl text-green-100 max-w-3xl mx-auto" data-id="element-249">
              Un sistema paso a paso basado en familias de fórmulas, gramajes
              exactos y control de calidad profesional, adaptado para hacerlo en
              tu cocina.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-250">
            {[{
            title: 'Precisión Absoluta',
            desc: "Olvídate de las 'pizcas'. Aprenderás a formular con porcentajes y gramos exactos para resultados replicables."
          }, {
            title: 'Seguridad Total',
            desc: 'Domina el pH, la conservación y la higiene para crear productos que duran meses sin riesgos.'
          }, {
            title: 'Personalización',
            desc: "Entiende el 'por qué' de cada ingrediente para adaptar las fórmulas a tu tipo de piel específico."
          }].map((item, i) => <div key={i} className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition-colors" data-id="element-251">
                <CheckCircle2 className="w-8 h-8 text-[#F5F2EA] mb-4" data-id="element-252" />
                <h3 className="text-xl font-bold mb-2" data-id="element-253">{item.title}</h3>
                <p className="text-green-100" data-id="element-254">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}